import httpManager from "@/app/shared/utils/httpManager";

export async function fetchUsersByQueue(queueId) {
  const response = await httpManager.get(`/queues/${queueId}/agents/`);

  return response?.data;
}
